import TimerUtil from "@/plugins/timer-util/TimerUtil";

/**
 * VueにプラグインとしてTimerUtilインスタンスを持たせる
 */
export default {
  install(Vue: any, options: any) {
    Vue.prototype.$timerUtil = new TimerUtil();
  }
};

/**
 * Vueの型定義にTimerUtilを追加する
 */
declare module "vue/types/vue" {
  interface Vue {
    $timerUtil: TimerUtil;
  }
  interface VueConstructor {
    $timerUtil: TimerUtil;
  }
}
